import { render, staticRenderFns } from "./otp-screen.vue?vue&type=template&id=c693825c&"
import script from "./otp-screen.vue?vue&type=script&lang=js&"
export * from "./otp-screen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports